import { useQuery } from "react-query"
import axiosClient from "../../../../../../../lib/axios"
import { Box, Button, Card, CardContent, Typography } from "@mui/material"
import { TableSimples } from "../../../../../../../components/BasicComponents/DisplayDados/TableSimples"
import { IDataRefUltimasVendas } from "../../../../../../../types/api/estoque/detalhar-referencia-ultimas-vendas"
import UltimasVendasSkeleton from "./UltimasVendasSkeleton"
import { useState } from "react"
import DialogUltimasVendas from "./DialogUltimasVendas"
import moment from "moment"


export default function CardUltimasVendas({ produtoId }: CardUltimasVendasProps) {

    const perPage = 5

    const [openDialog, setOpenDialog] = useState(false)

    const { data, isLoading } = useQuery({
        queryKey: ['ultimas-vendas', produtoId],
        queryFn: () => axiosClient.get(`/estoque/detalhar-referencia-ultimas-vendas`, {
            params: {
                produto_id: produtoId,
                per_page: perPage
            }
        }),
    })

    const ultimasVendas: IDataRefUltimasVendas[] = data?.data.data || []
    const carregando = isLoading || !ultimasVendas

    const headers = [
        { label: 'Loja', numeric: false },
        { label: 'Data', numeric: true },
    ]

    const rows = ultimasVendas.map((venda) => ({
        columns: [
            { value: venda.nome_loja, numeric: false },
            { value: moment(venda.data_venda).format('DD/MM/YYYY'), numeric: true },
        ]
    }))

    if (carregando) {
        return <UltimasVendasSkeleton />
    }

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" mb={2}>
                    Últimas vendas
                </Typography>

                {
                    ultimasVendas.length === 0 && (
                        <Typography variant="body1" color="text.secondary">
                            Nenhuma venda encontrada
                        </Typography>
                    )
                }

                {
                    ultimasVendas.length > 0 && (
                        <TableSimples
                            headers={headers}
                            rows={rows}
                            total={
                                (data?.data.total - perPage) > 0 
                                ? {
                                    label: '',
                                    value: `+ ${data?.data.total - perPage} registro(s)`,
                                    monetary: false
                                }
                                : undefined
                            }
                        />
                    )
                }

                <Box display="flex" justifyContent="flex-end" mt={1}>
                    <Button
                        variant="outlined"
                        size="small"
                        disabled={ultimasVendas.length === 0}
                        onClick={() => setOpenDialog(true)}
                    >
                        Ver mais
                    </Button>
                </Box>
            </CardContent>

            {
                openDialog && (
                    <DialogUltimasVendas
                        open={openDialog}
                        onClose={() => setOpenDialog(false)}
                        produtoId={produtoId}
                    />
                )
            }
        </Card>
    )
}

interface CardUltimasVendasProps {
    produtoId: number
}